module.exports = __webpack_public_path__ + "kerbin/app/images/icons/silhouette.27454041.png";